import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  Container,
  Grid,
  Paper,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
} from "@mui/material";
import Layout from "../Layout";
import { ApplicationState } from "../../store";
import { withFormik, FormikProps, Form, Field, FormikValues } from "formik";
import PageHeading from "../../common/pageHeading/PageHeading";
import ObmTerminalTable from "./obmTerminalTable/ObmTerminalTable";
import useSession from "../../effects/useSession";
import pageStyles from "../pageStyles";
import FormSubmitButtons from "../../common/buttons/FormSubmitButtons";

export default function OnBoardMerchant(): React.ReactElement {
  const classes = pageStyles();
  const session = useSession();
  const location = useLocation();

  const merchantState = useSelector(
    (state: ApplicationState) => state.merchant
  );
  const merchant = merchantState?.data?.data;

  const { terminals } = (location?.state as any) || null;

  const InnerForm = (props: FormikProps<FormikValues>) => {
    const { touched, errors, isSubmitting, values, setFieldValue } = props;
    const [showModal, setShowModal] = React.useState(false);
    // const forceUpdate = useForceUpdate();

    return (
      <Form className={classes.formWrapper as string}>
        <Grid container alignItems="flex-start" spacing={3}>
          <Grid item xs={12}>
            <FormControl style={{ width: "100%" }}>
              <InputLabel id="group-select-label">Merchant*</InputLabel>

              <Field name="Merchant" as={Select} fullWidth>
                {merchant?.map((mer, idx) => {
                  return (
                    <MenuItem key={idx} value={mer.attributes.Name}>
                      {mer.attributes.Name}
                    </MenuItem>
                  );
                })}
              </Field>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <ObmTerminalTable terminal={terminals} />
          </Grid>

          <FormSubmitButtons />
        </Grid>
      </Form>
    );
  };
  const EditForm = withFormik({
    // mapPropsToValues: data => {
    //   // return mapDataToForm(data);
    // },
    handleSubmit: (values) => {
      // console.log("submit");
      // const callback = (err: string | null, data: UserGroup | null) => {
      //     if (err) {
      //         setShowError(true);
      //     } else {
      //         history(-1);
      //     }
      // };
      // const data = mapFormToData(values);
      // dispatch(saveRequest(data, callback));
    },
  })(InnerForm);

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading heading="On Board Merchant" />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <EditForm />
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}
